import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CmsItem } from '@coin/shared/cms/util';
import { V2ButtonComponent, V2TextInputComponent } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';
import { CMS_BUTTON_ICONS, CmsButtonIcon } from '@coin/shared/core/util-enums';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'coin-cms-button',
  templateUrl: './cms-button.component.html',
  styleUrls: ['./cms-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatFormFieldModule,
    MatLabel,
    TranslateModule,
    MatSelectModule,
    FormsModule,
    V2ButtonComponent,
    V2TextInputComponent,
    TitleCasePipe
  ]
})
export class CmsButtonComponent {
  @Input() item: CmsItem<'button'>;
  @Input() contentEdit = false;

  protected readonly CmsButtonIcons = CMS_BUTTON_ICONS;
  protected readonly buttonIcons = Object.keys(CMS_BUTTON_ICONS);

  public buttonStyles = ['primary', 'secondary'] as const;

  public buttonDisplayFn(icon: string): CmsButtonIcon {
    return this.CmsButtonIcons[icon];
  }

  public openPage(link: string): void {
    window.open(link, '_blank');
  }
}
